import Wrapper from "../assets/wrappers/Rates";
import { AiOutlineCheck } from "react-icons/ai";
const Rates = () => {
  return (
    <Wrapper name="packages">
      <div className="container">
        <h3 data-aos="fade-up">Treatment Options & Packages</h3>

        <div className="item-container">
          <div className="item" data-aos="fade-up">
            <h4>Initial Assessment</h4>
            <div className="content">
              <p className="price">60 mins</p>
              <p>Comprehensive</p>
            </div>

            <div className="list">
              <h5>Detailed Evaluation</h5>
              <ul>
                <li>
                  <AiOutlineCheck className="check-icon" /> Full body assessment
                </li>
                <li>
                  <AiOutlineCheck className="check-icon" /> Medical history review
                </li>
                <li>
                  <AiOutlineCheck className="check-icon" /> Personalized diagnosis
                </li>
              </ul>
            </div>
          </div>
          <div className="item" data-aos="fade-up">
            <h4>Follow-up Session</h4>
            <div className="content">
              <p className="price">60 mins</p>
              <p>Therapy & Rehab</p>
            </div>
            <div className="list">
              <h5>Hands-on Treatment</h5>
              <ul>
                <li>
                  <AiOutlineCheck className="check-icon" /> Manual therapy
                </li>
                <li>
                  <AiOutlineCheck className="check-icon" /> Therapeutic exercises
                </li>
                <li>
                  <AiOutlineCheck className="check-icon" /> Progress tracking
                </li>
              </ul>
            </div>
          </div>
          <div className="item" data-aos="fade-up">
            <h4>Home Visit</h4>
            <div className="content">
              <p className="starting">Call for</p>
              <p className="price">Details</p>
            </div>
            <div className="list">
              <p className="details">
                We bring expert care to your doorstep. <br className="dnone" />
                Contact us for availability!{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Rates;
